import {
  ResponsesPensionItemResponse,
  ResponsesPortfolioResponse,
  ResponsesStatementFixedIncomeResponse,
  ResponsesStatementResponse,
  ResponsesTitlesResponse,
} from '@genial/services/dist/models';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { statementOptionQueryState } from '../../../../../../../store/customerDetail/stataments/atom';
import { StatementsOptionData } from '../../../../../../../store/customerDetail/stataments/types';

import { CurrentAccountItem } from './CurrentAccount';
import { DirectTreasuryItem } from './DirectTreasury';
import { FixedIncomeItem } from './FixedIncome';
import { FundItem } from './Fund';
import { PensionItem } from './Pension';

interface ItemProps {
  data: StatementsOptionData;
}

export const Item: React.FC<ItemProps> = ({ data }) => {
  const statementOptionQuery = useRecoilValue(statementOptionQueryState);

  const component = {
    'current-account': <CurrentAccountItem data={data as ResponsesStatementResponse} />,
    'fixed-income': <FixedIncomeItem data={data as ResponsesStatementFixedIncomeResponse} />,
    fund: <FundItem data={data as ResponsesPortfolioResponse} />,
    pension: <PensionItem data={data as ResponsesPensionItemResponse} />,
    'direct-treasury': <DirectTreasuryItem data={data as ResponsesTitlesResponse} />,
  };

  return component[statementOptionQuery || 'current-account'];
};
